import React, { Component, useState, useEffect  } from "react"
import axios from 'axios';

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Nav,
  TabContent,
  TabPane,
  Label,
  Button,
  Input,
  InputGroup,
} from "reactstrap"

function Tab3({activeTab, updateActiveTab}) {
  return (
    <div>
           <TabContent activeTab={activeTab} className="mt-4">
    <TabPane tabId="3" id="buy-tab">
    <h4 className="card-title mb-4">Import Proceeds</h4>

        <div>
            
        </div>
    </TabPane>
    </TabContent>
</div>
  )
}

export default Tab3